export default "/bundles/assets/photo8_e652c85492cfd877a171222cae46f41e.png";